import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const TipsAndTutorialEnglishAuctionStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .main-content {
    min-height: calc(100vh - 267px);
    padding-right: 0px;
    position: relative;
  }

  .video-wrapper {
    flex: 0 0 55%;
    justify-content: center;
  }

  .vdo {
    padding-right: 30px;
  }

  .guide-custom {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 20px 10px;
    column-gap: 10px;
    border-radius: 6px;
    min-height: 70px;
    border: 1px solid transparent;
    cursor: pointer;

    &.active {
      background-color: ${VARIABLES.COLORS.GRAY_7};
      border-color: ${VARIABLES.COLORS.GRAY_2};
      padding: 20px 10px;
      cursor: default;
    }

    &:hover {
      background-color: ${VARIABLES.COLORS.GRAY_4};
    }
  }

  .guide-info {
    display: flex;

    .order {
      margin-right: 10px;
      width: 20px;
    }
  }

  .menu-wrapper {
    flex: 0 0 45%;

    &::before {
      content: '';
      display: flex;
      background-color: ${VARIABLES.COLORS.GRAY_11};
      min-height: 100%;
      width: 1px;
      position: absolute;
      top: 0;
    }
  }

  .menu {
    width: 100%;

    .menu-title {
      color: ${VARIABLES.COLORS.BLUE_1};
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.BG};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_BOLD};
    }

    .sup-title {
      color: ${VARIABLES.COLORS.GRAY_10};
    }

    .menu-title-wrapper {
      border-bottom: 1px solid ${VARIABLES.COLORS.GRAY_11};
      padding: 0 30px 20px;
    }

    .guide {
      color: ${VARIABLES.COLORS.BLUE_1};
      padding: 10px 30px;
      border-bottom: 1px solid ${VARIABLES.COLORS.GRAY_11};

      &:last-child {
        border-bottom: none;
      }
    }

    .icon-play {
      width: 8px;
      margin-top: 6px;
    }
  }

  .time-skip {
    font-size: 14px;
    margin-top: 4px;
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1280.98px) {
    .time-skip {
      font-size: 12px;
      margin-top: 2px;
    }

    .menu .icon-play {
      width: 6px;
      margin-top: 4px;
    }

    .guide-info {
      .order {
        width: 10px;
      }
    }

    .menu {
      .menu-title {
        font-size: 20px;
      }
    }
  }

  @media all and (max-width: 991.98px) {
    .video-wrapper,
    .menu-wrapper {
      flex-basis: 100%;
    }

    .vdo {
      padding-right: 10px;
    }

    .menu-wrapper {
      &::before {
        display: none;
      }
    }

    .time-skip {
      font-size: 12px;
    }

    .menu {
      padding-right: 10px;

      .menu-title-wrapper {
        padding: 20px 0;
      }

      .guide {
        padding: 12px 0;
      }
    }

    .guide-custom {
      min-height: auto;
    }

    .page-button {
      margin-right: 0;

      span {
        display: none;
      }

      &.tip {
        flex-wrap: wrap;
        gap: 10px;
        justify-content: flex-end;
      }
    }
  }
`
